<form #form="ngForm">
    <span *ngIf="paciente">
        <div class="row">
            <div class="col-6">
                <plex-phone *ngIf="paciente" label="Celular:" [(ngModel)]="telefono" (change)="cambioTelefono=true"
                            name="telefono"></plex-phone>
            </div>
            <div class="col-6">
                <plex-text *ngIf="carpetaEfector" (change)="cambiarCarpeta()" label="Nro Carpeta" name="nroCarpeta"
                           [(ngModel)]="carpetaEfector.nroCarpeta"></plex-text>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <seleccionar-financiador [paciente]="paciente"
                                         (setFinanciador)="setFinanciador($event)"></seleccionar-financiador>
            </div>
        </div>
        <div class="row" *ngIf="agenda && agenda.tipoPrestaciones.length > 1">
            <div class="col">
                <plex-select [(ngModel)]="tipoPrestacion" name="tipoPrestacion" label="Tipo de prestación"
                             [data]="agenda.tipoPrestaciones" placeholder="Seleccione el tipo de prestación"
                             [required]="true">
                </plex-select>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <plex-datetime type="time" [(ngModel)]="horaTurno" [min]="inicio" [max]="fin" [required]="true"
                               name="horaTurno" label="Hora Turno">
                </plex-datetime>
            </div>
            <div *ngIf="agenda?.link" class="col">
                <plex-text placeholder="Ingrese link turno virtual" [(ngModel)]="turno_link" [required]="true"
                           name="turno_link" label="Link">
                </plex-text>
            </div>
            <div class="col-12">
                <plex-text label="Observaciones" name="nota" multiline="true" [(ngModel)]="nota"
                           (change)="verificarNota()"></plex-text>
            </div>
        </div>
        <div class="row" class="botones">
            <plex-button type="danger" label="Cancelar" (click)="cancelar()">
            </plex-button>
            <plex-button *ngIf="paciente" [validateForm]="form" label="Guardar" type="success"
                         (click)="verTurnosFuturos($event)" [disabled]="!disableGuardar">
            </plex-button>
        </div>
        <ng-container *ngIf="modalTurnosRepetidos">
            <plex-modal #modal size="sm" [startOpen]="true" [allowEscClose]="false" [allowBackdropClose]="false">
                <plex-icon name="alert-outline" size="sm" type="warning mt-2 mb-2"></plex-icon>
                <plex-modal-subtitle type="warning" class="font-subtitle text-muted text-center">Este paciente ya posee
                    turno para <b>{{ tipoPrestacion.term }}</b>, deséa asignarlo de todas formas?
                </plex-modal-subtitle>
                <br>
                <main>
                    <div>
                        <ul class="list-item-group" *ngFor="let turno of turnosFuturos; let i = index">
                            <li class="list-item text-capitalize">
                                <div><b>Fecha y hora:</b> {{ turno.horaInicio | date:'EEEE dd/MM/yyyy HH:mm' }}
                                </div>
                                <div><b>Organización:</b> {{ turno.organizacion }}</div>
                            </li>
                        </ul>
                    </div>
                </main>
                <plex-button class="mb-4" modal left type="danger" (click)="modalClose()">
                    Cancelar
                </plex-button>
                <plex-button class="mb-4" modal right type="success" (click)="guardar()">
                    Aceptar
                </plex-button>
            </plex-modal>
        </ng-container>
    </span>
</form>